module.exports = __webpack_public_path__ + "static/media/folder.ffadd6d1.svg";